module.exports = reactI18next;


//////////////////
// WEBPACK FOOTER
// external "reactI18next"
// module id = 3
// module chunks = 1